// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-slider-container .gyramais-slider .ant-slider-rail {
  height: 0.5rem;
  border-radius: 1rem;
  transform: translateY(-0.14rem);
}
.gyramais-slider-container .gyramais-slider .ant-slider-track {
  background-color: var(--primary-button-color);
  height: 0.5rem;
  border-radius: 1rem;
  transform: translateY(-0.14rem);
}
.gyramais-slider-container .gyramais-slider .ant-slider-handle {
  transform: scale(1.2) translateX(-0.38rem) !important;
  border: solid 1px #C9D3CC;
}
.gyramais-slider-container .gyramais-slider .ant-slider-step .ant-slider-dot {
  border-color: var(--primary-button-color);
}
.gyramais-slider-container .gyramais-slider .ant-slider-mark .ant-slider-mark-text {
  color: #C9D3CC;
  font-weight: 400;
  transition: 0.3s;
}
.gyramais-slider-container .gyramais-slider .ant-slider-mark .ant-slider-mark-text-active {
  color: #000000D9;
  margin-top: 0.4rem;
}
.gyramais-slider-container .gyramais-slider:hover .ant-slider-rail {
  background-color: #f5f5f5;
}
.gyramais-slider-container .gyramais-slider.warning-gyramais-slider .ant-slider-track {
  background-color: var(--warning-color);
}
.gyramais-slider-container .gyramais-slider.danger-gyramais-slider .ant-slider-track {
  background-color: var(--danger-color);
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled) .ant-slider-handle:hover,
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled) .ant-slider-handle:focus {
  transform: scale(1.4) translateX(-0.3rem) !important;
  border: solid 1px #C9D3CC;
  box-shadow: none;
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled):hover .ant-slider-handle {
  transform: scale(1.4) translateX(-0.3rem) !important;
  border: solid 1px #C9D3CC;
}
.gyramais-slider-container .gyramais-slider:not(.ant-slider-disabled):hover .ant-slider-rail {
  background-color: #e1e1e1;
}
.gyramais-slider-container .gyramais-slider-value {
  font-weight: 500;
}
.gyramais-slider-container .gyramais-slider-range-value {
  transform: translateY(-0.5rem);
}
.gyramais-slider-container .gyramais-slider-value-input {
  border-top: none;
  border-left: none;
  border-right: none;
  border-radius: 0;
  min-height: auto;
  width: 8rem;
  height: 1.6rem;
}
.gyramais-slider-container .gyramais-slider-value-input .ant-input-number-handler-wrap {
  display: none;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-focused {
  box-shadow: none;
  border-bottom-color: var(--primary-button-color);
}
.gyramais-slider-container .gyramais-slider-value-input input {
  padding: 0;
  font-weight: 500;
  font-size: 0.875rem;
  text-align: center;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-disabled {
  background-color: transparent;
}
.gyramais-slider-container .gyramais-slider-value-input.ant-input-number-disabled:hover {
  border-bottom-color: #d9d9d9;
}
.gyramais-slider-skeleton {
  width: 100%;
  border-radius: 0.8rem !important;
}
.gyramais-slider-skeleton span {
  width: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/sdk/Slider/styles.less"],"names":[],"mappings":"AAAA;EAGM,cAAA;EACA,mBAAA;EAEA,+BAAA;AAFN;AAJA;EAWM,6CAAA;EACA,cAAA;EACA,mBAAA;EAEA,+BAAA;AALN;AAVA;EAmBM,qDAAA;EAEA,yBAAA;AAPN;AAdA;EA0BQ,yCAAA;AATR;AAjBA;EAgCQ,cAAA;EACA,gBAAA;EACA,gBAAA;AAZR;AAtBA;EAsCQ,gBAAA;EACA,kBAAA;AAbR;AAkBI;EAEI,yBAAA;AAjBR;AAqBI;EAEI,sCAAA;AApBR;AAwBI;EAEI,qCAAA;AAvBR;AA6BQ;;EAEE,oDAAA;EAEA,yBAAA;EACA,gBAAA;AA5BV;AAgCM;EAEI,oDAAA;EAEA,yBAAA;AAhCV;AA4BM;EAQI,yBAAA;AAjCV;AAhDA;EAwFI,gBAAA;AArCJ;AAnDA;EA2FI,8BAAA;AArCJ;AAtDA;EA+FI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,gBAAA;EACA,WAAA;EACA,cAAA;AAvCJ;AA/DA;EAyGM,aAAA;AAvCN;AA0CI;EACE,gBAAA;EACA,gDAAA;AAxCN;AAtEA;EAkHM,UAAA;EAEA,gBAAA;EACA,mBAAA;EACA,kBAAA;AA1CN;AA6CI;EACE,6BAAA;AA3CN;AA6CM;EACE,4BAAA;AA3CR;AAiDA;EACE,WAAA;EACA,gCAAA;AA/CF;AA6CA;EAKI,sBAAA;AA/CJ","sourcesContent":[".gyramais-slider-container {\n  .gyramais-slider {\n    .ant-slider-rail {\n      height: .5rem;\n      border-radius: 1rem;\n\n      transform: translateY(-.14rem);\n\n    }\n    \n    .ant-slider-track {\n      background-color: var(--primary-button-color);\n      height: .5rem;\n      border-radius: 1rem;\n\n      transform: translateY(-.14rem);\n    }\n\n    .ant-slider-handle {\n      transform: scale(1.2) translateX(-.38rem) !important;\n\n      border: solid 1px #C9D3CC;\n    }\n\n    .ant-slider-step {\n      .ant-slider-dot {\n        border-color: var(--primary-button-color);\n      }\n    }\n\n    .ant-slider-mark {\n      .ant-slider-mark-text {\n        color: #C9D3CC;\n        font-weight: 400;\n        transition: .3s;\n      }\n\n      .ant-slider-mark-text-active {\n        color: #000000D9;\n        margin-top: .4rem;\n      }\n  \n    }\n\n    &:hover {\n      .ant-slider-rail {\n        background-color: #f5f5f5;\n      }\n    }\n\n    &.warning-gyramais-slider {\n      .ant-slider-track {\n        background-color: var(--warning-color);\n      }\n    }\n\n    &.danger-gyramais-slider {\n      .ant-slider-track {\n        background-color: var(--danger-color);\n      }\n    }\n\n    &:not(.ant-slider-disabled) {\n      .ant-slider-handle {\n        &:hover,\n        &:focus {\n          transform: scale(1.4) translateX(-.3rem) !important;\n          \n          border: solid 1px #C9D3CC;\n          box-shadow: none;\n        }\n      }\n\n      &:hover {\n        .ant-slider-handle {\n          transform: scale(1.4) translateX(-.3rem) !important;\n  \n          border: solid 1px #C9D3CC;\n        }\n\n        .ant-slider-rail {\n          background-color: #e1e1e1;\n        }\n      }\n    }\n  }\n  \n  .gyramais-slider-value {\n    font-weight: 500;\n  }\n  .gyramais-slider-range-value {\n    transform: translateY(-.5rem);\n  }\n\n  .gyramais-slider-value-input {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-radius: 0;\n\n    min-height: auto;\n    width: 8rem;\n    height: 1.6rem;\n\n    .ant-input-number-handler-wrap {\n      display: none;\n    }\n\n    &.ant-input-number-focused {\n      box-shadow: none;\n      border-bottom-color: var(--primary-button-color);\n    }\n    \n    input {\n      padding: 0;\n\n      font-weight: 500;\n      font-size: 0.875rem;\n      text-align: center;\n    }\n\n    &.ant-input-number-disabled {\n      background-color: transparent;\n      \n      &:hover {\n        border-bottom-color: #d9d9d9;\n      }\n    }\n  }\n}\n\n.gyramais-slider-skeleton {\n  width: 100%;\n  border-radius: .8rem !important;\n\n  span {\n    width: 100% !important;\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
